<template>
    <div :class="isExternalSeller?'d-flex flex-column fill-height is-external-seller' :'d-flex flex-column fill-height'" id="statistics">
        <v-row ref="headerFilters" class="flex-grow-0">
            <data-table-filters v-if="!isMobile"
                :name="tb('Estatísticas - Consumos')"
                :has-active-filters="hasActiveFilters"
                :has-expanded-active-filters="hasExpandedActiveFilters"
                :filters="filters"
                :schema="tSchema(schema)"
                @expand-active-filters="hasExpandedActiveFilters = $event"
                @remove-filter="removeFilter"
                @refresh="refresh(true)"
                @clear-filters="onClearFilters()"
                @operator-changed="changeCurrentOperator($event)"
                showOperatorSelection
                changeViewTypeEnabled
                :operatorType="currentOperator"
            >
            </data-table-filters>
            <div class="col wrap-title-filters" v-else >
                <filters-dialog
                    :name="tb('Estatísticas - Consumos')"
                    :isConsumptions="true"
                    :has-active-filters="hasActiveFilters"
                    :has-expanded-active-filters="hasExpandedActiveFilters"
                    :filters="filters"
                    :schema="tSchema(schema)"
                    @expand-active-filters="hasExpandedActiveFilters = $event"
                    @remove-filter="removeFilter"
                    @refresh="refresh(true)"
                    @clear-filters="onClearFilters()"
                    @operator-changed="changeCurrentOperator($event)"
                    showOperatorSelection
                    changeViewTypeEnabled
                    :operatorType="currentOperator"
                    >
                </filters-dialog>
            </div>
        </v-row>

        <v-row>
            <v-col>
                <portal to="v-form-base">
                    <v-form-base :model="filters" :schema="tSchema(schema)" @input="onFiltersChanged"></v-form-base>
                </portal>

                <app-card class="d-flex flex-column align-stretch fill-height py-4 px-4">
                    <template v-slot:image>
                        <div class="d-flex justify-center">
                            <v-tabs show-arrows centered id="myprovet-tabs" v-model="selectedTabIndex" next-icon="mdi-chevron-right" prev-icon="mdi-chevron-left" height="35px" style="border-radius: 8px; padding-left: 11px">
                                <v-tabs-slider color="#154579"></v-tabs-slider>
                                    <div v-for="item in visibleTabItems" :key="item.tab">
                                        <v-tab class="myprovet-tab-item"  v-if="item.tab=='AFFINITY' && showAffinityTab">
                                            {{ tb(item.tab) }}
                                        </v-tab>
                                        <v-tab class="myprovet-tab-item"  v-if="item.tab=='AFFINITY' && !showAffinityTab" style="display: none;">
                                            {{ tb(item.tab) }}
                                        </v-tab>
                                        <v-tab class="myprovet-tab-item"   v-if="item.tab!='AFFINITY'">
                                            {{ tb(item.tab) }}
                                        </v-tab>

                                    </div>
                            </v-tabs>
                        </div>

                        <loading-indicator v-if="showLoading" :no-data="activeChartNoData" :loading="showLoading"> </loading-indicator>

                        <template v-else-if="selectedTabIndex === consumptionsTabIndex && consumptionsTabIndex !== -1">
                            <div class="fill-height fill-height-c">
                                <div class="d-flex fill-height justify-space-between" id="tab_content_consumptions">
                                    <div class="d-flex flex-grow-1 flex-column align-center wrap-content-consumptions" :style="`overflow-y: auto; height: ${datatableSize}px`">
                                        <div class="mt-4 wrap-content-rvrplc" style="width: 100%;">
                                            <v-row >
                                                <v-col cols="12" md="3" sm="3" >
                                                        <v-card :elevation="0"
                                                        >
                                                        <v-card-text>
                                                            <div v-if="isExternalSeller">{{ tb('Valor Total(VB)') }}</div>
                                                            <div v-else v-html="isTablet?tb('Total c/ Rappel Valorizado'):tb('Valor Total com Rappel Valorizado')"></div>
                                                            <p class="text-h5 text--primary" v-html="showSummaryTotalValue?summaryTotalValue:'-'"></p>
                                                        </v-card-text>
                                                        </v-card>
                                                </v-col>
                                                <v-col cols="12" md="3" sm="3">
                                                    <v-card :elevation="0"
                                                    >
                                                    <v-card-text  v-if="!isExternalSeller">
                                                        <div>{{ tb('Valor Rappel Propec') }}</div>
                                                        <p class="text-h5 text--primary" v-html="showSummaryTotalValue?rappelTotalDiscountSum:'-'"></p>
                                                    </v-card-text>
                                                    </v-card>
                                                </v-col>
                                                <v-col cols="12" md="3" sm="3" >
                                                        <v-card :elevation="0"
                                                        >
                                                        <v-card-text v-if="!isExternalSeller">
                                                            <div>{{ tb('Valor Líquido Compras') }}</div>
                                                            <p class="text-h5 text--primary" v-html="showSummaryTotalValue?rappelTotalNetSum:'-'"></p>
                                                        </v-card-text>
                                                        </v-card>
                                                </v-col>
                                                <v-col cols="12" md="3" sm="3" >
                                                    <!--<v-select v-bind="{...schemaCustom }" @change="changePHomologo" :value="currentHMvalue"> </v-select>-->
                                                    <v-select class="wrap-select-ph"
                                                            prependInnerIcon="mdi-list-status"
                                                            v-model="selectedItems"
                                                            :items="listPH"
                                                            :label="tb('Periodo Homólogo')"
                                                            multiple
                                                            @change="changePHomologo"
                                                            >
                                                            <template v-slot:prepend-item>
                                                                <v-list-item
                                                                ripple
                                                                @mousedown.prevent
                                                                @click="toggle"
                                                                >
                                                                <v-list-item-action>
                                                                    <v-icon :color="selectedItems.length > 0 ? 'blue darken-1' : ''">
                                                                    {{ icon }}
                                                                    </v-icon>
                                                                </v-list-item-action>
                                                                <v-list-item-content>
                                                                    <v-list-item-title>
                                                                    {{ $t('clientMenu.selectAll') }}
                                                                    </v-list-item-title>
                                                                </v-list-item-content>
                                                                </v-list-item>
                                                                <v-divider class="mt-2"></v-divider>
                                                            </template>
                                                    </v-select>
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <div class="mt-4 " style="width: 100%;" >
                                            <div class="fill-height" style="float: left;  width: 100%;" v-show="selectedItems.length==0">
                                                <area-chart-hc :height="isMobile?'520px':'420px'" class="fill-height" curve="straight" isPriceChart :series="summary" :categories="categories" ></area-chart-hc>
                                            </div>
                                            <div class="fill-height" style="float: left;  width: 100%;" v-show="selectedItems.length>0">
                                                <bar-chart-hc  :height="isMobile?'520px':'420px'"  class="fill-height"  :series="summaryPH" :categories="categoriesPH" ></bar-chart-hc>
                                            </div>
                                        </div>
                                     </div>
                                </div>
                            </div>
                        </template>

                        <template v-else-if="selectedTabIndex === top10TabIndex">
                            <div class="mt-4"></div>

                            <div class="fill-height fill-height-c">
                                <div class="d-flex fill-height justify-space-between" id="tab_content_performance">

                                    <div class="d-flex flex-grow-1 flex-column align-center wrap-content-performance" :style="`overflow-y: auto; height: ${datatableSize}px`">
                                        <div v-for="(chart,indexChart) in performanceList" :key="indexChart" style="width:95%;">
                                            <v-divider v-if="indexChart>0 && indexChart <= (performanceList.length-1)"></v-divider>
                                            <div  class="d-flex flex-row-reverse">
                                            <v-checkbox class="ml-2 show-checkbox-qtd " v-if="!hidePrices"
                                                    v-model="chart.show_qty"
                                                    :label="tb('Ver análise p/ qtd')"
                                                    hide-details
                                                ></v-checkbox>
                                            </div>
                                            <div  class="d-flex flex-column justify-center">

                                                <donut-chart-hc :showTotal="checkIfShowTotal(chart.label)"  :isPriceChart="true" :title="tb(chart.label)" :subtitle="isExternalSeller?'':tb('(por preço de compra com rappel valorizado)')" v-show="!chart.show_qty"
                                                    :height="isMobile?'520px':'420px'"
                                                    :series="getSeriesFromChart(chart.key_price)" :key-target="chart.target_price" >
                                                </donut-chart-hc>
                                                <donut-chart-hc  :showTotal="checkIfShowTotal(chart.label)" :isPriceChart="false"  :title="tb(chart.label)" :subtitle="tb('(por quantidade com bónus)')" v-show="chart.show_qty"
                                                    :height="isMobile?'520px':'420px'"
                                                    :series="getSeriesFromChart(chart.key_qty)" :key-target="chart.target_qty" >
                                                </donut-chart-hc>
                                            </div>

                                            <div class="my-4"></div>

                                            <!--<div class="d-flex flex-column justify-center">-->
                                                    <!--<bar-chart :divwidth="divwidth" :title="`TOP 10 ${chartName} por quantidade (com bónus)`" toolbar horizontal hide-legend show-data-labels distributed :offset-x="30" is-float :max-label-width="barLabelWidth" :series="getChartQuantitySeries" height="320px" bar-height="40%" :width="barWidth">
                                                    <template #content>
                                                        <div class="text-caption font-size-xs text-center performance-info" style="width:100%;">
                                                            Nos Top 10 são apresentados apenas dados <b>POSITIVOS</b> descartando movimentos que tenham saldo negativo, pelo que a soma dos valores apresentados pode diferir dos Totais Compras.
                                                        </div>
                                                    </template>
                                                </bar-chart>-->
                                                <!--<div class="text-caption font-size-xs text-center performance-info" style="width:80%;">
                                                            Nos Top 10 são apresentados apenas dados <b>POSITIVOS</b> descartando movimentos que tenham saldo negativo, pelo que a soma dos valores apresentados pode diferir dos Totais Compras.
                                                </div>-->
                                             <!---</div>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="selectedTabIndex === affinityTabIndex">
                            <div class="mt-4"></div>

                            <div class="fill-height fill-height-c">
                                <div class="d-flex fill-height justify-space-between" id="tab_content_performance">

                                    <div class="d-flex flex-grow-1 flex-column align-center wrap-content-performance" :style="`overflow-y: auto; height: ${datatableSize}px`">
                                        <div v-for="(chart2,indexChart2) in affinityList" :key="indexChart2" style="width:95%;">
                                            <v-divider v-if="indexChart2>0 && indexChart2 <= (affinityList.length-1)"></v-divider>
                                            <div  class="d-flex flex-row-reverse">
                                               <v-checkbox class="ml-2 show-checkbox-qtd " v-if="!hidePrices"
                                                    v-model="chart2.show_qty"
                                                    :label="tb('Ver análise p/ qtd')"
                                                    hide-details
                                                ></v-checkbox>
                                                <v-col cols="12" md="3" sm="4" v-if="!hidePrices">
                                                    <!--<v-select v-bind="{...schemaCustom }" @change="changePHomologo" :value="currentHMvalue"> </v-select>-->
                                                    <v-select class="wrap-select-ph"
                                                            prependInnerIcon="mdi-list-status"
                                                            v-model="selectedItemsAffinity"
                                                            :items="listPH"
                                                            :label="tb('Periodo Homólogo')"
                                                            multiple
                                                            @change="changePHomologoAffinity"
                                                            >
                                                            <template v-slot:prepend-item>
                                                                <v-list-item
                                                                ripple
                                                                @mousedown.prevent
                                                                @click="toggleAffinity"
                                                                >
                                                                <v-list-item-action>
                                                                    <v-icon :color="selectedItemsAffinity.length > 0 ? 'blue darken-1' : ''">
                                                                    {{ iconAffinity }}
                                                                    </v-icon>
                                                                </v-list-item-action>
                                                                <v-list-item-content>
                                                                    <v-list-item-title>
                                                                    {{ $t('clientMenu.selectAll') }}
                                                                    </v-list-item-title>
                                                                </v-list-item-content>
                                                                </v-list-item>
                                                                <v-divider class="mt-2"></v-divider>
                                                            </template>
                                                    </v-select>
                                                </v-col>
                                            </div>
                                            <div class="" style="width: 100%;" >
                                                <div class="fill-height" style="float: left;  width: 100%;" v-show="selectedItemsAffinity.length==0">
                                                    <donut-chart-hca :showTotal="checkIfShowTotal(chart2.label)"  :isPriceChart="true" :title="tb(chart2.label)" :subtitle="tb('(por preço de compra com rappel valorizado)')" v-show="!chart2.show_qty"
                                                    :height="isMobile?'520px':'420px'"
                                                    :series="getSeriesFromAffinityChart(chart2.key_price)" :key-target="chart2.target_price" >
                                                    </donut-chart-hca>
                                                    <donut-chart-hca  :showTotal="checkIfShowTotal(chart2.label)" :isPriceChart="false"  :title="tb(chart2.label)" :subtitle="tb('(por quantidade com bónus)')" v-show="chart2.show_qty"
                                                        :height="isMobile?'520px':'420px'"
                                                        :series="getSeriesFromAffinityChart(chart2.key_qty)" :key-target="chart2.target_qty" >
                                                    </donut-chart-hca>
                                                </div>
                                                <div class="fill-height" style="float: left;  width: 100%;" v-show="selectedItemsAffinity.length>0">
                                                    <bar-chart-hca :title="tb(chart2.label)" :subtitle="tb('(por preço de compra com rappel valorizado)')" :height="isMobile?'520px':'420px'"  class="fill-height"  v-show="!chart2.show_qty" :isPriceChart="true"  :series="summaryPHAP" :categories="categoriesPHA" ></bar-chart-hca>
                                                    <bar-chart-hca  :title="tb(chart2.label)" :subtitle="tb('(por quantidade com bónus)')"  :height="isMobile?'520px':'420px'"  class="fill-height"  v-show="chart2.show_qty" :isPriceChart="false"  :series="summaryPHAQ" :categories="categoriesPHA" ></bar-chart-hca>
                                                </div>
                                            </div>
                                            <!--<div class="d-flex flex-column justify-center" v-show="selectedItemsAffinity.length===0">

                                                <donut-chart-hca :showTotal="checkIfShowTotal(chart2.label)"  :isPriceChart="true" :title="tb(chart2.label)" :subtitle="tb('(por preço de compra com rappel valorizado)')" v-show="!chart2.show_qty"
                                                    :height="isMobile?'520px':'420px'"
                                                    :series="getSeriesFromAffinityChart(chart2.key_price)" :key-target="chart2.target_price" >
                                                </donut-chart-hca>
                                                <donut-chart-hca  :showTotal="checkIfShowTotal(chart2.label)" :isPriceChart="false"  :title="tb(chart2.label)" :subtitle="tb('(por quantidade com bónus)')" v-show="chart2.show_qty"
                                                    :height="isMobile?'520px':'420px'"
                                                    :series="getSeriesFromAffinityChart(chart2.key_qty)" :key-target="chart2.target_qty" >
                                                </donut-chart-hca>
                                            </div>
                                            <div class="d-flex flex-column justify-center" style="float: left;  width: 100%;" v-show="selectedItemsAffinity.length>0">
                                                <bar-chart-hc  :height="isMobile?'520px':'420px'"  class="fill-height"  :series="summaryPH" :categories="categoriesPH" ></bar-chart-hc>
                                            </div>-->

                                            <!--<div class="d-flex flex-column justify-center">-->
                                                    <!--<bar-chart :divwidth="divwidth" :title="`TOP 10 ${chartName} por quantidade (com bónus)`" toolbar horizontal hide-legend show-data-labels distributed :offset-x="30" is-float :max-label-width="barLabelWidth" :series="getChartQuantitySeries" height="320px" bar-height="40%" :width="barWidth">
                                                    <template #content>
                                                        <div class="text-caption font-size-xs text-center performance-info" style="width:100%;">
                                                            Nos Top 10 são apresentados apenas dados <b>POSITIVOS</b> descartando movimentos que tenham saldo negativo, pelo que a soma dos valores apresentados pode diferir dos Totais Compras.
                                                        </div>
                                                    </template>
                                                </bar-chart>-->
                                                <!--<div class="text-caption font-size-xs text-center performance-info" style="width:80%;">
                                                            Nos Top 10 são apresentados apenas dados <b>POSITIVOS</b> descartando movimentos que tenham saldo negativo, pelo que a soma dos valores apresentados pode diferir dos Totais Compras.
                                                </div>-->
                                             <!---</div>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="selectedTabIndex === simplifiedTabIndex">
                            <div class="mt-4"></div>

                            <pure-datatable
                                :key="selectedTabIndex"
                                ref="datatable_simplified"
                                endpoint="/api/statistics/consumptions/simplified_view"
                                @data-changed="dataChanged('datatable_simplified')"
                                :queryParams="queryParams"
                                v-slot:default="{ vOn, vBind, isLoading, setLocalOptions, setCurrentOperator, onChangeQueryBuilder }"
                            >
                                <v-data-table id="v_table_simplified_view"
                                    class="elevation-1 d-flex flex-column justify-space-between no-extra-padding-data-table"
                                    :style="`border-radius: 16px; height: ${datatableSize}px;`"
                                    fixed-header
                                    multi-sort
                                    :headers="tHeaders(simplified_view_headers)"
                                    :header-props="headerProps"
                                    :hide-default-headers="isMobile"
                                    @update:options="refreshDatatable(onChangeQueryBuilder, setLocalOptions, setCurrentOperator, $event)"
                                    v-on="vOn"
                                    v-bind="vBind"
                                    hide-default-footer
                                    :no-data-text="$t('table.noData')"
                                    :no-results-text="$t('table.noResults')"
                                    :loading="isMobile?isLoading:false"
                                    :loading-text="$t('table.loading')"
                                    :footer-props="{
                                        showFirstLastPage: false,
                                        itemsPerPageOptions: itemsPerPageOptions,
                                        itemsPerPageText: $t('table.itemsPerPage'),
                                    }"
                                >
                                    <template v-if="!isMobile"  #[`item.reference`]="{ item }">
                                        <div class="d-flex justify-start align-center">
                                            {{ item.reference }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile"  #[`item.designation`]="{ item }">
                                        <div class="datatable-designation-text">
                                            {{ item.designation }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile"  #[`item.laboratory_name`]="{ item }">
                                        <div class="d-flex justify-start align-center">
                                            {{ item.laboratory_name }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile"  #[`item.quantity`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{ formatQuantity(item.quantity) }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile"  #[`item.bonus_total`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{ formatQuantity(item.bonus_total) }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile"  #[`item.total_quantity`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{ formatQuantity(item.total_quantity) }}
                                        </div>
                                    </template>

                                    <template v-if="(!isMobile && !isExternalSeller)"  #[`item.net_total`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{ formatPrice(item.net_total) }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile && !isExternalSeller"  #[`item.discount`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{ formatPrice(item.discount) }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile"  #[`item.gross_total`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{ formatPrice(item.gross_total) }}
                                        </div>
                                    </template>
                                <template v-if="isMobile" v-slot:item="{ item, index }">
                                <tr>
                                    <v-card
                                        elevation="2"
                                    >
                                    <v-row>
                                        <v-col class="d-flex flex-column col pt-0 pb-0">
                                            <v-row class="d-flex align-start pt-0 pb-0">

                                                <v-col  class="col col-12 pt-0 pb-0 px-0">
                                                    <v-row class="d-flex align-start pt-0 pb-0">
                                                        <v-col class="col col-12 pt-0 pb-0 px-0">
                                                            <div class="pl-0 datatable-designation-text design">
                                                                {{ item.designation }}
                                                            </div>
                                                        </v-col>
                                                        <v-col  class="col col-12 pt-0 pb-0 px-0">
                                                            <div class="pl-0 datatable-lable-text laboratory">
                                                                {{ item.laboratory_name}}
                                                            </div>
                                                        </v-col>
                                                        <v-col  class="col col-12 pt-0 pb-0 px-0">
                                                            <div class="pl-0 datatable-lable-text code">
                                                                {{ item.reference}}
                                                            </div>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                 <v-row class="d-flex align-start pt-0 pb-0 mt-2">
                                                    <v-col class="col col-6 px-0 pt-0 pb-0 wrap-l">
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field">{{ tb('SUBTOTAL QTD.') }}</v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field">{{ tb('SUBTOTAL QTD. BÓNUS') }}</v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field">{{ tb('TOTAL QTD.') }}</v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field invoices"  v-if="!isExternalSeller && !hidePrices">{{ tb('VAL. LIQ. COMPRA') }}</v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field invoices"  v-if="!isExternalSeller && !hidePrices">{{ tb('RAPPEL') }}</v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field invoices" v-if="!hidePrices"  v-html="isExternalSeller?'VALOR TOTAL (VB)':'TOTAL C/ RAPPEL VALORIZADO'" ></v-col>
                                                    </v-col>
                                                    <v-col class="col col-6  pt-0 pb-0 wrap-r">
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                                <div class="datatable-designation-text">
                                                                        {{ formatQuantity(item.quantity) }}
                                                               </div>
                                                        </v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                            <div class="datatable-designation-text">
                                                                        {{ formatQuantity(item.bonus_total)}}
                                                               </div>
                                                        </v-col>

                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                            <div class="datatable-designation-text">
                                                                        {{ formatQuantity(item.total_quantity) }}
                                                               </div>
                                                        </v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field-r" v-if="!isExternalSeller&& !hidePrices">
                                                            <div class="datatable-designation-text">
                                                                        {{ formatPrice(item.net_total) }}
                                                               </div>
                                                        </v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field-r" v-if="!isExternalSeller && !hidePrices">
                                                            <div class="datatable-designation-text">
                                                                        {{ formatPrice(item.discount) }}
                                                             </div>
                                                        </v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field-r" v-if="!hidePrices">
                                                            <div class="datatable-designation-text">
                                                                        {{ formatPrice(item.gross_total)}}
                                                             </div>
                                                        </v-col>

                                                    </v-col>
                                                 </v-row>
                                            </v-row>
                                        </v-col>
                                    </v-row>

                                </v-card>
                            </tr>
                             </template>
                                    <template v-slot:footer="scope">
                                        <div>
                                            <div class="datatable-footer-border"></div>

                                            <data-table-footer
                                                :showExport="canExportSimplified()"
                                                :scope="scope"
                                                @export="exportSimplifiedData"
                                                @updateOptions="refreshDatatable(onChangeQueryBuilder, setLocalOptions, setCurrentOperator, $event)"
                                                :showOrderButton="false"
                                                :isLoading="isLoading"
                                                style="height: fit-content"
                                            ></data-table-footer>
                                        </div>
                                    </template>
                                </v-data-table>
                            </pure-datatable>
                        </template>

                        <template v-else-if="selectedTabIndex === detailedTabIndex">
                            <div class="mt-4"></div>

                            <pure-datatable
                                :key="selectedTabIndex"
                                ref="datatable_detailed"
                                endpoint="/api/statistics/consumptions/detailed_view"
                                @data-changed="dataChanged('datatable_detailed')"
                                :queryParams="queryParams"
                                v-slot:default="{ vOn, vBind, isLoading, setLocalOptions, setCurrentOperator, onChangeQueryBuilder }"
                            >
                                <v-data-table id="v_table_detailed_view"
                                    class="elevation-1 d-flex flex-column justify-space-between no-extra-padding-data-table"
                                    :style="`border-radius: 16px; height: ${datatableSize}px;`"
                                    fixed-header
                                    multi-sort
                                    :headers="tHeaders(detailed_view_headers)"
                                    :header-props="headerProps"
                                    :hide-default-headers="isMobile"
                                    @update:options="refreshDatatable(onChangeQueryBuilder, setLocalOptions, setCurrentOperator, $event)"
                                    v-on="vOn"
                                    v-bind="vBind"
                                    hide-default-footer
                                    :no-data-text="$t('table.noData')"
                                    :no-results-text="$t('table.noResults')"
                                    :loading="isMobile?isLoading:false"
                                    :loading-text="$t('table.loading')"
                                    :footer-props="{
                                        showFirstLastPage: false,
                                        itemsPerPageOptions: itemsPerPageOptions,
                                        itemsPerPageText: $t('table.itemsPerPage'),
                                    }"
                                >
                                <template v-if="!isMobile" v-for="header in detailed_view_headers" v-slot:[`header.${header.value}`]="{ header }">
                                    <div tabindex="0" :class="isStatisticsLoading?'th-header-l':'th-header'">{{ tb(header.text) }}</div>

                                </template>
                                    <template v-if="!isMobile" #[`item.reference`]="{ item }">
                                        <div class="d-flex justify-start align-center">
                                            {{ item.reference }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.document_number`]="{ item }">
                                        <div class="datatable-designation-text">
                                            {{ item.document_number }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.invoice_date`]="{ item }">
                                        <div class="datatable-designation-text">
                                            {{ formatDate(item.invoice_date) }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.designation`]="{ item }">
                                        <div class="datatable-designation-text">
                                            {{ item.designation }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.laboratory_name`]="{ item }">
                                        <div class="d-flex justify-start align-center">
                                            {{ item.laboratory_name }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.quantity`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{  formatQuantity(item.quantity) }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.bonus_total`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{ formatQuantity(item.bonus_total) }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.total_quantity`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{ formatQuantity(item.total_quantity) }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile && !isExternalSeller && !hidePrices" #[`item.net_total`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{ formatPrice(item.net_total) }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile && !isExternalSeller && !hidePrices" #[`item.discount`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{ formatPrice(item.discount) }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile && !hidePrices" #[`item.gross_total`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{ formatPrice(item.gross_total) }}
                                        </div>
                                    </template>
                                    <template v-if="isMobile" v-slot:item="{ item, index }">
                                        <tr>
                                            <v-card
                                                elevation="2"
                                                >
                                                <v-row>
                                                    <v-col class="d-flex flex-column col pt-0 pb-0">
                                                        <v-row class="d-flex align-start pt-0 pb-0">

                                                            <v-col  class="col col-12 pt-0 pb-0 px-0">
                                                                <v-row class="d-flex align-start pt-0 pb-0">
                                                                    <v-col class="col col-12 pt-0 pb-0 px-0">
                                                                        <div class="pl-0 datatable-designation-text design">
                                                                            {{ item.designation }}
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col  class="col col-12 pt-0 pb-0 px-0">
                                                                        <div class="pl-0 datatable-lable-text laboratory">
                                                                            {{ item.laboratory_name}}
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col  class="col col-12 pt-0 pb-0 px-0">
                                                                        <div class="pl-0 datatable-lable-text code">
                                                                            {{ item.reference}}
                                                                        </div>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                            <v-row class="d-flex align-start pt-0 pb-0 mt-2">
                                                                <v-col class="col col-6 px-0 pt-0 pb-0 wrap-l">
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field">{{ tb('Nº DOC.') }}</v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field">{{ tb('DATA DOC.') }}</v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field">{{ tb('SUBTOTAL QTD.') }}</v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field">{{ tb('SUBTOTAL QTD. BÓNUS') }}</v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field">{{ tb('TOTAL QTD.') }}</v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field invoices" v-if="!isExternalSeller && !hidePrices">{{ tb('VAL. LIQ. COMPRA') }}</v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field invoices" v-if="!isExternalSeller  && !hidePrices">{{ tb('RAPPEL') }}</v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field invoices" v-if="!hidePrices" v-html="isExternalSeller?'VALOR TOTAL (VB)':'TOTAL C/ RAPPEL VALORIZADO'"></v-col>
                                                                </v-col>
                                                                <v-col class="col col-6  pt-0 pb-0 wrap-r">
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                                            <div class="datatable-designation-text">
                                                                                    {{ item.document_series }}
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                                            <div class="datatable-designation-text">
                                                                                    {{ formatDate(item.invoice_date) }}
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                                            <div class="datatable-designation-text">
                                                                                    {{ formatQuantity(item.quantity) }}
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                                        <div class="datatable-designation-text">
                                                                                    {{ formatQuantity(item.bonus_total)}}
                                                                        </div>
                                                                    </v-col>

                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                                        <div class="datatable-designation-text">
                                                                                    {{ formatQuantity(item.total_quantity) }}
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" v-if="!isExternalSeller && !hidePrices">
                                                                        <div class="datatable-designation-text">
                                                                                    {{ formatPrice(item.net_total) }}
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" v-if="!isExternalSeller && !hidePrices">
                                                                        <div class="datatable-designation-text">
                                                                                    {{ formatPrice(item.discount) }}
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r"  v-if="!hidePrices">
                                                                        <div class="datatable-designation-text">
                                                                                    {{ formatPrice(item.gross_total)}}
                                                                        </div>
                                                                    </v-col>

                                                                </v-col>
                                                            </v-row>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>

                                            </v-card>
                                        </tr>

                                    </template>


                                    <template v-slot:footer="scope">
                                        <div>
                                            <div class="datatable-footer-border"></div>

                                            <data-table-footer
                                                :showExport="canExportDetailed()"
                                                :scope="scope"
                                                @export="exportDetailedData"
                                                @updateOptions="refreshDatatable(onChangeQueryBuilder, setLocalOptions, setCurrentOperator, $event)"
                                                :showOrderButton="false"
                                                :isLoading="isLoading"
                                                style="height: fit-content"
                                            ></data-table-footer>
                                        </div>
                                    </template>
                                </v-data-table>
                            </pure-datatable>
                        </template>

                        <template v-else-if="selectedTabIndex === rappelTabIndex">
                            <div class="mt-4 fill-height fill-height-c add-overflow" id="tab_rappel">
                                <div class="fill-height" style="float: left; width: calc(100% - 180px)" v-if="!isMobile">
                                    <area-chart :title="tb('Estatísticas de consumos (Rappel)')" class="fill-height" curve="straight" :height="'340px'" isPriceChart :series="consumptions"></area-chart>
                                </div>
                                <div style="width: 180px; float: right" v-if="!isMobile">
                                    <div class="d-flex flex-column align-center">
                                        <span class="text-center consumptions-totals-title dark-blue-color">{{ tb('Totais') }}</span>
                                        <div class="mt-7 text-center font-size-md">
                                            <span>{{ tb('Total Valores Período:') }}</span><br />
                                            <span>{{ rappelTotalValue }} </span><br />
                                            <span>{{ tb('Líquido Consumos:') }}</span><br />
                                            <span>{{ rappelTotalNetSum }} </span><br />
                                            <span>{{ tb('Rappel Propec:') }}</span><br />
                                            <span>{{ rappelTotalDiscountSum }} </span><br />
                                        </div>
                                    </div>
                                </div>
                                <div class=""  v-if="isMobile">
                                    <area-chart :title="tb('Estatísticas de consumos (Rappel)')" :height="isMobile?'520px':'auto'"  class="fill-height" curve="straight" isPriceChart :series="consumptions"></area-chart>
                                        <div class="d-flex flex-column align-center">
                                            <span class="text-center consumptions-totals-title dark-blue-color">{{ tb('Totais') }}</span>
                                            <div class="mt-4 text-center font-size-md">
                                                <span>{{ tb('Total Valores Período:') }}</span><br />
                                                <span>{{ rappelTotalValue }} </span><br />
                                                <span>{{ tb('Líquido Consumos:') }}</span><br />
                                                <span>{{ rappelTotalNetSum }} </span><br />
                                                <span>{{ tb('Rappel Propec:') }}</span><br />
                                                <span>{{ rappelTotalDiscountSum }} </span><br />
                                         </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                </app-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useBranchStore } from '@/Stores/branch';
import { useAppStore } from '@/Stores/app';
import { axios } from '@/Services/Backend';
import { buildQueryObjectFromModel } from '@arentia/atools/QueryBuilder';
import MainLayout from '@/Layouts/MainLayout';
import VFormBase from 'vuetify-form-base';
import PureDatatable from '@arentia/atools/PureDatatable';
import moment from 'moment';
import { formatIntegerPrice } from '@/Mixins/Formatting'
import ResizeObserver from 'resize-observer-polyfill';
import ProgressChart from '@/Components/Charts/ProgressChart.vue';
import AreaChartHc from '@/Components/Charts/AreaChartHC.vue';
import DonutChartHc from '@/Components/Charts/DonutChartHC.vue';
import DonutChartHca from '@/Components/Charts/DonutChartHCA.vue';
import BarChartHc from '@/Components/Charts/BarChartHC.vue';
import BarChartHca from '@/Components/Charts/BarChartHCA.vue';
import _ from 'lodash';
// @Note: the chart types are as follows.
const PRICE_CHART_SUFFIX = 'per_price';
const QUANTITY_CHART_SUFFIX = 'per_quantity';

export default {
    layout: MainLayout,

    components: {
        VFormBase,
        PureDatatable,
        ProgressChart,
        AreaChartHc,
        DonutChartHc,
        BarChartHc,
        DonutChartHca,
        BarChartHca
    },

    props: {
        model: [Object, Array],
        schema: [Object, Array],
        simplified_view_headers: Array,
        detailed_view_headers: Array,
    },

    data: () => ({
        listPH:['N - 1','N - 2'],
        previousItems: [],
        comparisonKey: '',
        selectedItems: [],
        selectedItemsAffinity: [],
        checkedSelectAll: false,
        currentHMvalue:null,
        schemaCustom2:{
                'dataFieldMiddleware':true,
                'dataFieldValue':[{'N - 1':1},
                        {'N - 2': 2},
                        {'N - 3': 3}],
                'dataFieldApplyOn':['start_date', 'end_date'],
                'label' : 'Periodo Homólogo',
                'prependInnerIcon' : 'mdi-list-status',
                //'col' :['cols' => 3, 'sm' => 3, 'md' => 3],
                'class' : 'mt-4 ml-4 myprovet-textfield',
                'dense' : true,
                'clearable' : true,
                'hideDetails' : true,
                'fullWidth' : true,
                'singleLine' : true,
                'multiple' : false,
                'returnObject' : true,
                'disabled': false,
                'dataIsHomologousPeriod' : false,
                'items' : ['N - 1','N - 2','N - 3'],
                'noDataText': 'Sem resultados',
        },
        schemaCustom:{
                'dataFieldMiddleware':true,
                'label' : 'Periodo Homólogo',
                'prependInnerIcon' : 'mdi-list-status',
                //'col' :['cols' => 3, 'sm' => 3, 'md' => 3],
                'class' : 'mt-4 ml-4 myprovet-textfield',
                'dense' : true,
                'clearable' : true,
                'hideDetails' : true,
                'fullWidth' : true,
                'singleLine' : true,
                'multiple' : true,
                'returnObject' : true,
                'disabled': false,
                'itemText':'name',
                'dataIsHomologousPeriod' : true,
                'items' : [{name:'N - 1',id:1},{name:'N - 2',id:2}],
                'noDataText': 'Sem resultados',
        },
        categories:[],
        categoriesPH:[],
        categoriesPHA:[],
        performanceList:[
            {label:'Produto',key_qty:'products_per_quantity',key_price:'products_per_price',target_price:'gross_sum',target_qty:'total_quantity','show_qty':false},
            {label:'Laboratório',key_qty:'laboratories_per_quantity',key_price:'laboratories_per_price',target_price:'gross_sum',target_qty:'total_quantity','show_qty':false},
            {label:'Classificação Farmacológica',key_qty:'pharma_compositions_per_quantity',key_price:'pharma_compositions_per_price',target_price:'gross_sum',target_qty:'total_quantity','show_qty':false},
            {label:'Espécie',key_qty:'species_per_quantity',key_price:'species_per_price',target_price:'gross_sum',target_qty:'total_quantity','show_qty':false},
            {label:'Substância ativa',key_qty:'active_substances_per_quantity',key_price:'active_substances_per_price',target_price:'gross_sum',target_qty:'total_quantity','show_qty':false},
            {label:'Vias de administração',key_qty:'administration_routes_per_quantity',key_price:'administration_routes_per_price',target_price:'gross_sum',target_qty:'total_quantity','show_qty':false},
        ],
        affinityList:[
         {label:'GAMA',key_qty:'brands_per_quantity',key_price:'brands_per_price',target_price:'gross_sum',target_qty:'total_quantity','show_qty':false,'color':null},
        ],
        barWidth:'1000px',
        barLabelWidth:320,
        barStyleWidth:'width:1000px;',
        divwidth:'',
        filters: {},
        queryParams: {},
        currentOperator: 'all',
        hasExpandedActiveFilters: false,
        datatableSize: 200,
        resizeObserver: null,

        timer: null,
        isStatisticsLoading: true,
        isPerformanceLoading: true,
        isAffinityLoading: true,
        hasStatisticsLoaded: false,
        hasPerformanceLoaded: false,
        hasAffinityLoaded: false,
        wasPerformanceTabSelected: false,
        wasAffinityTabSelected:false,
        showAffinityTab:false,
        itemsPerPageOptions:window.innerWidth>=768&&window.innerWidth<=1366?[20,50,100]:[20,40,50],
        selectedTabIndex: 0,
        tabItems: [{ tab: 'CONSUMOS' }, { tab: 'TOP 10' }, {tab:'AFFINITY'},{ tab: 'VISTA SIMPLIFICADA' }, { tab: 'VISTA DETALHADA' }/*, { tab: 'RAPPEL' }*/],

        statistics: {
            consumptions: [],
            consumptionsPH: [],
        },

        performance: {
            currentPage: 1,
            lastPage: 1,

            // Top 10
            products_per_price: null,
            products_per_quantity: null,

            laboratories_per_price: null,
            laboratories_per_quantity: null,

            pharma_compositions_per_price: null,
            pharma_compositions_per_quantity: null,

            species_per_price: null,
            species_per_quantity: null,

            active_substances_per_price: null,
            active_substances_per_quantity: null,

            administration_routes_per_price: null,
            administration_routes_per_quantity: null,
        },
        affinityStats: {
            brands_per_price: null,
            brands_per_quantity: null,
        },

        rappelTotalValue: '0 €',
        rappelTotalNetSum: '0 €',
        rappelTotalDiscountSum: '0 €',

        minEndDate: null,
        maxEndDate: null,

        chartNames: ['Produto', 'Laboratório', 'Classificação Farmacológica', 'Espécie', 'Substância ativa', 'Via de administração'],
        first:false,
        showSummaryTotalValue:true
    }),

    watch: {
        'branchStore.branch': {
            handler: function (branch) {
                if (!branch) return;

                this.queryParams.branch_id = branch.id;
               // this.refresh(true);
                if(!this.isMobile){
                    this.refresh(true);
                }else{
                    if(this.first){
                        this.refresh(true);
                    }else{
                        this.getPrefilledBranches()
                    }
                }
            },
            immediate: true,
        },

        selectedTabIndex: {
            handler: function () {
                this.refresh();
            },
            immediate: true,
        },

        hasStatisticsLoaded: {
            handler: function (loaded) {
                if (loaded && !this.wasPerformanceTabSelected) this.getPerformance(true);
                if (loaded && !this.wasAffinityTabSelected && this.showAffinityTab) this.getAffinity();
            },
        },

        hasPerformanceLoaded: {
            handler: function (loaded) {
                if (loaded && this.wasPerformanceTabSelected) this.getStatistics();
            },
        },
        hasAffinityLoaded: {
            handler: function (loaded) {
                if (loaded && this.wasAffinityTabSelected)this.getStatistics();
            },
        },
        hidePrices: {
            handler: function (val) {
                if (val) {
                    this.$nextTick(() => {
                        this.selectedTabIndex = this.top10TabIndex;
                        this.performanceList.forEach(chart => { chart.show_qty = true; });
                        this.affinityList.forEach(chart => { chart.show_qty = true; });
                    });
                }
            },
            immediate: true,
        },
    },

    created() {
        if(this.isMobile){
            this.getPrefilledBranches()
        }else{
            this.applyDefaultFilters();
        }
        let portrait = window.matchMedia("(orientation: portrait)");
        portrait.addEventListener("change", (e)=> {
             // Do change
             this.fixChartWidth()
             this.prepareResponsiveBehaviour();
        })
    },
    mounted() {
        this.prepareResponsiveBehaviour();
        window.EventBus.$emit('collapse-categories-card', true);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.computeDatatableSize);
        this.resizeObserver?.unobserve(this.$refs.headerFilters);
    },

    computed: {
        ...mapStores(useUserStore, useBranchStore,useAppStore),

        hasActiveFilters() {
            return Object.values(this.filters)
                .filter((x) => x) // ignore null or undefined
                .some((x) => (typeof x === 'string' && x !== '') || (Array.isArray(x) && x.length > 0) || (typeof x === 'object' && Object.keys(x).length > 0));
        },

        //
        // Charts
        //
        hasStatistics() {
            return Object.keys(this.statistics).some((key) => this.statistics[key].length);
        },

        hasPerformance() {
            return Object.keys(this.performance).some((key) => this.performance[key]?.length);
        },
        hasAffinity() {
            return Object.keys(this.affinityStats).some((key) => this.affinityStats[key]?.length);
        },

        hidePrices() {
            return this.userStore.hasPermissionTo('Consumptions - Hide Prices');
        },
        visibleTabItems() {
            if (this.hidePrices) {
                return this.tabItems.filter(item => item.tab !== 'CONSUMOS');
            }
            return this.tabItems;
        },
        consumptionsTabIndex() {
            return this.visibleTabItems.findIndex(item => item.tab === 'CONSUMOS');
        },
        top10TabIndex() {
            return this.visibleTabItems.findIndex(item => item.tab === 'TOP 10');
        },
        affinityTabIndex() {
            return this.visibleTabItems.findIndex(item => item.tab === 'AFFINITY');
        },
        simplifiedTabIndex() {
            return this.visibleTabItems.findIndex(item => item.tab === 'VISTA SIMPLIFICADA');
        },
        detailedTabIndex() {
            return this.visibleTabItems.findIndex(item => item.tab === 'VISTA DETALHADA');
        },
        rappelTabIndex() {
            return this.visibleTabItems.findIndex(item => item.tab === 'RAPPEL');
        },

        showLoading() {
            if (this.selectedTabIndex === this.consumptionsTabIndex && this.consumptionsTabIndex !== -1) return this.isStatisticsLoading;
            if (this.selectedTabIndex === this.top10TabIndex) return this.isPerformanceLoading ? true : !this.hasPerformanceLoaded;
            if (this.selectedTabIndex === this.affinityTabIndex) return this.isAffinityLoading ? true : !this.hasAffinityLoaded;

            return false;
        },

        activeChartNoData() {
            if (this.selectedTabIndex === this.consumptionsTabIndex && this.consumptionsTabIndex !== -1) {
                return !this.hasStatistics;
            }
            if (this.selectedTabIndex === this.top10TabIndex) {
                return !this.hasPerformance;
            }
            if (this.selectedTabIndex === this.affinityTabIndex) {
                return !this.hasAffinity;
            }

            return false; // the datatables have their own 'no data' state.
        },

        summary() {
            if (this.statistics.consumptions.length === 0) {
                return [];
            }
            let obj = {}
            if(!this.isExternalSeller){
                obj={
                    gross_sum:'Valor Total Com Rappel Valorizado',
                    net_sum:'Valor Líquido Compras',
                    discount_sum:'Valor Rappel Propec'
                }
            }else{
                obj={
                        gross_sum:'Valor Total(VB)',
                }
            }

            return this.buildChartData(obj);
        },
        summaryPH() {
            if (_.size(this.statistics.consumptionsPH) === 0) {
                return [];
            }
            return _.has(this.statistics.consumptionsPH,'series')?this.statistics.consumptionsPH.series:[]
        },

        summaryTotalValue() {
            let total = 0;
            let totalNetSum = 0;
            let totalDiscountSum = 0;

            for (const consumption of this.statistics.consumptions) {
                total += parseFloat(consumption.gross_sum);
                totalDiscountSum +=  parseFloat(consumption.discount_sum);
                totalNetSum +=  parseFloat(consumption.net_sum);
            }
            if(this.selectedItems.length >0){
                total=this.statistics.consumptionsPH.total_rv
                totalNetSum=this.statistics.consumptionsPH.total_lc
                totalDiscountSum= this.statistics.consumptionsPH.total_rp;

            }
            this.rappelTotalNetSum = formatIntegerPrice(totalNetSum,2,2);
            this.rappelTotalDiscountSum = formatIntegerPrice(totalDiscountSum,2,2);
            this.rappelTotalValue = formatIntegerPrice(total);
            return formatIntegerPrice(total,2,2);
        },
        summaryPHAP() {
            if (_.size(this.affinityStats.brands_per_price) === 0) {
                return [];
            }
            return _.has(this.affinityStats.brands_per_price,'series')?this.affinityStats.brands_per_price.series:[]
        },
        summaryPHAQ() {
            if (_.size(this.affinityStats.brands_per_quantity) === 0) {
                return [];
            }
            return _.has(this.affinityStats.brands_per_quantity,'series')?this.affinityStats.brands_per_quantity.series:[]
        },
        consumptions() {
            this.resetTotalRappelValues();

            if (this.statistics.consumptions.length === 0) {
                return [];
            }
            //if(!this.isExternalSeller){
                const series = new Map([
                    ['Valor Líquido Consumos', 'net_sum'],
                    ['Valor Rappel Propec', 'discount_sum'],
                ]);
            //}else{

            //}


            const result = this.buildChartData(series);
            this.computeRappelTotalValues(result);

            return result;
        },

        hasMoreChartPages() {
            return this.performance.currentPage < this.performance.lastPage;
        },

        chartName() {
            return this.chartNames[this.performance.currentPage - 1];
        },

        getPriceSeries() {
            return this.getPropertyFromChart('name', 'gross_sum', PRICE_CHART_SUFFIX);
        },
        getChartPriceSeries() {
            return [{ data: this.getPriceSeries }];
        },
        getChartPriceLabels() {
            let lables=[]
            _.each(this.getPriceSeries,(o)=>{
               lables.push(o.x)
            })
            return lables
        },

        getQuantitySeries() {
            return this.getPropertyFromChart('name', 'total_quantity', QUANTITY_CHART_SUFFIX);
        },
        getChartQuantitySeries() {
            return [{ data: this.getQuantitySeries }];
        },

        isPerformanceTabSelected() {
            return this.selectedTabIndex === 1;
        },
        isAffinityTabSelected() {
            return this.selectedTabIndex === 2;
        },
        isMobile(){
            return this.appStore.mobile_ls?false:this.appStore.is_mobile;
        },
        headerProps(){
            return this.appStore.header_props
        },
        icon () {
            if (this.selectedItems.length === 2) return 'mdi-close-box'
            if (this.selectedItems.length > 0 && !(this.selectedItems.length === 2)) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        iconAffinity () {
            if (this.selectedItemsAffinity.length === 2) return 'mdi-close-box'
            if (this.selectedItemsAffinity.length > 0 && !(this.selectedItemsAffinity.length === 2)) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        isTablet(){
            return this.appStore.is_tablet
        },
        isExternalSeller(){
            return this.userStore.hasPermissionTo('Only list products of the associated seller\'s laboratories')
        }
    },

    methods: {
        changePHomologo(val){
            //setTimeout(()=>{
                this.getStatistics();
            //},500)
        },
        changePHomologoAffinity(val){
            //setTimeout(()=>{
                this.getAffinity();
            //},500)
        },
        toggle(){
                this.$nextTick(() => {
                    if (this.selectedItems.length === 2) {
                        this.selectedItems = []
                    } else {
                        this.selectedItems = this.listPH.slice()
                    }
                    this.getStatistics();
                })
                //setTimeout(()=>{
                   // this.getStatistics();
                //},500)
        },
        toggleAffinity(){
                this.$nextTick(() => {
                    if (this.selectedItemsAffinity.length === 2) {
                        this.selectedItemsAffinity = []
                    } else {
                        this.selectedItemsAffinity = this.listPH.slice()
                    }
                    this.getAffinity();
                })
                //setTimeout(()=>{
                   // this.getStatistics();
                //},500)
        },
        checkIfShowTotal(val){

            if(val=='Espécie'||val=='Substância ativa'){
                return false
            }
            return true
        },
        getSeriesFromChart(key){
           return this.performance[key]
        },
        getSeriesFromAffinityChart(key){
           if(this.affinityStats[key]){
             return _.has(this.affinityStats[key],'series')?[]:this.affinityStats[key]
           }
           return []
        },
        getPrefilledBranches(){
             axios
                .get('/api/branches/prefilled-branches')
                .then((response) => {
                       let result = response.data
                       this.model['branch__id']=[];
                       for(let field in result){
                          this.model['branch__id'].push({id:result[field].id})
                       }
                       this.applyDefaultFilters();
                       if(!this.first){
                            this.$nextTick(_=>{
                                this.first=true
                                this.refresh(true)
                            })
                       }
                }).catch((error) => {
                    console.log(error);
                });
        },
        fixChartWidth(){
            let width = window.innerWidth
            this.$nextTick(()=>{
                if(width==1366){
                    this.barWidth= '860px'
                    this.barLabelWidth=280
                    this.barStyleWidth='width:860px;'
                    this.divwidth='50vw'
                }else if(width==1024){
                    this.barWidth= '820px'
                    this.barLabelWidth=280
                    this.barStyleWidth='width:820px;'
                    this.divwidth='70vw'
                }else if(width==820){
                    this.barWidth= '620px'
                    this.barLabelWidth=120
                    this.barStyleWidth='width:620px;'
                    this.divwidth='70vw'
                }else if(width==768){
                    this.barWidth= '520px'
                    this.barLabelWidth=120
                    this.barStyleWidth='width:520px;'
                    this.divwidth='70vw'
                }else{
                    this.barWidth= '800px'
                    this.barLabelWidth=320
                    this.barStyleWidth='width:800px;'
                    this.divwidth='50vw'
                }
            })

        },
        dataChanged(targetRef) {
            const wrapper = this.$refs[targetRef]?.$el?.querySelector('div.v-data-table__wrapper');
            this.scrollDatatableToTop(this.$vuetify, wrapper);
        },

        /*buildChartData(series) {
            const result = [];

            for (const [label, field] of series) {
                result.push({
                    name: label,
                    data: this.statistics.consumptions.map((it) => ({ x: it.date, y: it[field] })),
                });
            }

            return result;
        },*/
        buildChartData(series) {
            this.showSummaryTotalValue = true
            const result = [];
             //console.log('buildChartData',series);
            /*for (const [label, field] of series) {
                result.push({
                    name: label,
                    data: this.statistics.consumptions.map((it) => ({ x: it.date, y: it[field] })),
                });
            }*/
            this.categories=[]
            let total = 0;
            let totalNetSum = 0;
            let totalDiscountSum = 0
            if(this.statistics.consumptions.length>0){
            _.each(series,(key,value)=>{
                    //console.log(key,value);
                    this.categories=[];
                    result.push({
                        name: key,
                        data: _.map(this.statistics.consumptions,(o)=>{
                            this.categories.push(o.date)
                            return parseFloat(o[value])
                        }),
                    });
            })
            }
            return result;
        },
        resetTotalRappelValues() {
            this.rappelTotalNetSum = '0 €';
            this.rappelTotalDiscountSum = '0 €';
            this.rappelTotalValue = '0 €';
        },

        computeRappelTotalValues(consumptions) {
            let total = 0;
            let totalNetSum = 0;
            let totalDiscountSum = 0;

            for (const consumption of consumptions) {
                for (const value of consumption.data) {
                    if (consumption.name == 'Valor Líquido Consumos' || consumption.name == 'Valor Rappel Propec') {
                        total += parseFloat(value.y);
                    }
                    if (consumption.name == 'Valor Líquido Consumos') {
                        totalNetSum += parseFloat(value.y);
                    }
                    if (consumption.name == 'Valor Rappel Propec') {
                        totalDiscountSum += parseFloat(value.y);
                    }
                }
            }

            this.rappelTotalNetSum = formatIntegerPrice(totalNetSum,2,2);
            this.rappelTotalDiscountSum = formatIntegerPrice(totalDiscountSum,2,2);

            this.rappelTotalValue = formatIntegerPrice(total);
        },

        getPropertyFromChart(label, property, type) {
            const pageIndex = this.performance.currentPage - 1;

            // Get the data for that type of chart, e.g. 'products_per_price'
            const keys = Object.keys(this.performance).filter((it) => it.endsWith(type));
            const key = keys.at(pageIndex);

            // And finally transform the array based on the requested property, e.g. 'products_per_price'
            //  will have a sum of the prices, not a quantity, so we'll request the sum property.
            return this.performance[key]?.filter((it) => it[property] > 0)?.map((it) => ({ x: it[label], y: it[property] }));
        },

        prepareResponsiveBehaviour() {
            this.fixChartWidth()
            const makeResponsive = () => {
                this.computeDatatableSize();
            };

            this.resizeObserver = new ResizeObserver(makeResponsive);
            this.resizeObserver.observe(this.$refs.headerFilters);

            window.addEventListener('resize', makeResponsive);

            makeResponsive();
        },

        computeDatatableSize() {
            const topElement = this.$refs.headerFilters;

            if (topElement) {
                const topHeight = topElement.getBoundingClientRect().bottom;
                const res = window.innerHeight - 159 - topHeight;
                this.datatableSize = res;
            }
        },

        removeFilter(filters, index) {
            filters.splice(index, 1);
            this.onFiltersChanged();
        },

        onFiltersChanged() {
            let hasAutoSearch = this.userStore.user?.auto_search_disabled
            //console.log('onFiltersChanged consumptions',this.isIOS(),hasAutoSearch);
            if(this.isIOS()){
                if(!hasAutoSearch){
                    this.setFiltersChanged()
                }
            }else{
                this.setFiltersChanged()
            }
        },
        setFiltersChanged(){
                this.refresh(true);
                window.EventBus.$emit('check-if-should-overflow');
                window.EventBus.$emit('check-if-should-underflow');
        },
        refresh(forceRequest = false) {
            if (!this.branchStore.branch) return;

            // Check if the start_date and end_date filters are valid (must be within a 1 year interval, will use start_date as the basis for all checks)
            if (this.filters.start_date != null) {
                // Set the limit end date to 1 year starting from the start_date
                this.minEndDate = this.filters.start_date;
                this.maxEndDate = moment(this.filters.start_date).add(2, 'year').format('YYYY-MM-DD');
                this.schema.end_date.minDate = this.minEndDate;
                this.schema.end_date.maxDate = this.maxEndDate;

                // If the other date is set and somehow exceeds the 1 year maximum gap, we'll adjust it accordingly
                if (this.filters.end_date) {
                    // if end date is set and is lower than start date, set a new end date 1 year from the start date
                    const minEndDate = moment(this.filters.start_date).format('YYYY-MM-DD');
                    if (moment(this.filters.end_date) < moment(minEndDate)) this.filters.end_date = moment(this.filters.start_date).add(1, 'year').format('YYYY-MM-DD');

                    // If end date is set and is higher than 1 year after the start date, set it to 1 year from the start date
                    const maxEndDate = moment(this.filters.start_date).add(2, 'year').format('YYYY-MM-DD');
                    if (moment(this.filters.end_date) > moment(maxEndDate)) this.filters.end_date = maxEndDate;
                }
            } else {
                // Clear the limit end date
                this.minEndDate = null;
                this.maxEndDate = null;
                this.schema.end_date.minDate = null;
                this.schema.end_date.maxDate = null;
            }

            if (forceRequest) {
                this.hasStatisticsLoaded = false;
                this.hasPerformanceLoaded = false;
                this.hasAffinityLoaded = false;

                // Debounce the statistics calls (both datatables already have the debouncing feature built-in).
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }

                if(_.has(this.filters,'product__laboratory__name')){

                     let indexAffinity= _.size(this.filters.product__laboratory__name) == 1 ? _.findIndex(this.filters.product__laboratory__name,{id:79}):-1
                     if(indexAffinity!=-1)
                        this.showAffinityTab=true
                     else{
                        this.showAffinityTab=false
                        if(this.selectedTabIndex===2){
                            this.selectedTabIndex=1
                        }
                     }

                }

                this.timer = setTimeout(() => {
                    this.wasPerformanceTabSelected = this.isPerformanceTabSelected;
                    this.wasAffinityTabSelected = this.isAffinityTabSelected;

                    if(this.wasAffinityTabSelected){
                        this.getAffinity(forceRequest)
                    }else{
                        this.wasPerformanceTabSelected ? this.getPerformance(forceRequest) : this.getStatistics();
                    }
                }, 500);
            }

            this.$nextTick(() => {
                if (this.$refs['datatable_simplified']) {
                    this.$refs['datatable_simplified'].setCurrentOperator(this.currentOperator);
                    this.$refs['datatable_simplified'].onChangeQueryBuilder(this.filters, this.schema);
                }
                if (this.$refs['datatable_detailed']) {
                    this.$refs['datatable_detailed'].setCurrentOperator(this.currentOperator);
                    this.$refs['datatable_detailed'].onChangeQueryBuilder(this.filters, this.schema);
                }
            });
        },

        refreshDatatable(onChangeQueryBuilder, setLocalOptions, setCurrentOperator, options) {
            if (options) {
                setLocalOptions(options);
            }

            setCurrentOperator(this.currentOperator);
            onChangeQueryBuilder(this.filters, this.schema);
        },

        getStatistics() {
            const query = buildQueryObjectFromModel(this.filters, this.schema, { operator: this.currentOperator });
            this.isStatisticsLoading = true;
            axios
                .post('/api/statistics/consumptions', {
                    ...this.queryParams,
                    queryObject: JSON.stringify(query),
                    selectedTab: this.tabItems[this.selectedTabIndex].tab,
                    homologous_period__id:this.selectedItems
                })
                .then((response) => {
                    if(_.has(response.data,'consumptions_1')){
                        this.prepareBarChart(response.data)
                    }else{
                        for (const key in this.statistics) {
                            if (response.data[key]) {
                                this.statistics[key] = response.data[key];
                            }
                        }
                    }
                })
                .catch((error) => {
                    for (const key in this.statistics) {
                        this.statistics[key] = [];
                    }
                    console.log(error.response);
                    this.showError(this.tb('Não foi possível carregar os dados pretendidos, por favor tente mais tarde.'));
                })
                .finally(() => {
                    this.hasStatisticsLoaded = true;
                    this.isStatisticsLoading = false;
                });
        },
        prepareBarChart(data){

         let obj={}
         let self = this
         let isMultiYear = false
         self.showSummaryTotalValue = true

         if(!this.isExternalSeller){
            obj = {
            categories:[],
            series:[{'name':'Valor Total Com Rappel Valorizado',data:[]},{'name':'Valor Líquido Compras',data:[]},{'name':'Valor Rappel Propec',data:[]}],
            total_rv:0,
            total_lc:0,
            total_rp:0
          }
         }else{
            obj = {
            categories:[],
            series:[{'name':'Valor Total(VB)',data:[]}],
            total_rv:0,
            total_lc:0,
            total_rp:0
          }
         }

          _.forEach(data, function(value, key) {
               if(_.size(value)){
                    let ctg= _.split(value[0].date,' ')
                    let size =_.size(value)
                    if(size>1){
                        let lstCtg = _.split(value[size-1].date,' ')
                        if(ctg[1] != lstCtg[1]){
                            let simpleCat=_.slice(lstCtg[1], -2).join('')+' / '+ _.slice(ctg[1], -2).join('')
                            obj.categories.push(simpleCat)
                            isMultiYear=true
                        }else{
                            obj.categories.push(ctg[1])
                        }
                    }else{
                        obj.categories.push(ctg[1])
                    }
               }

                let totalRV=0
                let totalRP=0
                let totalLC=0
                _.each(value,(cs)=>{
                    totalRV= totalRV + parseFloat(cs.gross_sum)
                    if(!self.isExternalSeller){
                        totalLC= totalLC+ parseFloat(cs.net_sum)
                        totalRP= totalRP+ parseFloat(cs.discount_sum)
                    }
                })
                obj.series[0].data.push(totalRV)
                obj.total_rv= obj.total_rv+totalRV

                if(!self.isExternalSeller){
                    obj.series[1].data.push(totalLC)
                    obj.total_lc= obj.total_lc+totalLC
                    obj.series[2].data.push(totalRP)
                    obj.total_rp= obj.total_rp+totalRP
                }
          })

          this.showSummaryTotalValue = isMultiYear?false:true
          this.statistics.consumptionsPH=obj
          this.categoriesPH=obj.categories

        },
        getPerformance(isForceRequest) {
            const query = buildQueryObjectFromModel(this.filters, this.schema, { operator: this.currentOperator });

            if (isForceRequest) {
                // Reset the performance to the default state, as the cache and pagination are invalid.
                Object.assign(this.$data.performance, this.$options.data.call(this).performance);
            }

            this.isPerformanceLoading = true;

            axios
                .post('/api/statistics/performance', {
                    ...this.queryParams,
                    queryObject: JSON.stringify(query),
                })
                .then((response) => {
                    for (const key in this.performance) {
                        if (response.data[key]) {
                            this.performance[key] = response.data[key];
                        }
                    }
                })
                .catch((error) => {
                    for (const key in this.performance) {
                        this.performance[key] = null;
                    }

                    console.log(error.response);
                    this.showError(this.tb('Não foi possível carregar os dados pretendidos, por favor tente mais tarde.'));
                })
                .finally(() => {
                    this.hasPerformanceLoaded = true;
                    this.isPerformanceLoading = false;
                });
        },
        getAffinity() {
            const query = buildQueryObjectFromModel(this.filters, this.schema, { operator: this.currentOperator });
            this.isAffinityLoading = true;
            axios
                .post('/api/statistics/affinity', {
                    ...this.queryParams,
                    queryObject: JSON.stringify(query),
                    homologous_period__id:this.selectedItemsAffinity
                })
                .then((response) => {

                    if(this.selectedItemsAffinity.length==0){
                        for (const key in this.affinityStats) {
                            if (response.data[key]) {
                                this.affinityStats[key] = response.data[key];
                            }
                        }
                        this.prepareAffinityChart();
                    }else{
                        this.prepareAffinityBarChart(response.data);
                    }

                })
                .catch((error) => {

                    for (const key in this.affinityStats) {
                        this.affinityStats[key] = null;
                    }
                    console.log(error.response);
                    this.showError(this.tb('Não foi possível carregar os dados pretendidos, por favor tente mais tarde.'));
                })
                .finally(() => {
                    this.hasAffinityLoaded = true;
                    this.isAffinityLoading = false;
                });
        },
        prepareAffinityChart(){

            let colorADV= '#154579';//#0C2340'
            let colorAVET= '#93b5e9'
            let colorLP= '#265c38'
            let colorBK= '#d29605'
            let colorNVD= '#E87722'
            let colorNVW= '#e99e66'

            _.each(this.affinityStats.brands_per_price,(bp)=>{
                    if(bp.name=='ADV'){
                        bp.color= colorADV
                        let ixAdv = _.findIndex(this.affinityStats.brands_per_quantity,{name:'ADV'})
                        this.affinityStats.brands_per_quantity[ixAdv].color= colorADV
                    }
                    if(bp.name=='AVET'){
                        bp.color= colorAVET
                        let ixAvet = _.findIndex(this.affinityStats.brands_per_quantity,{name:'AVET'})
                        this.affinityStats.brands_per_quantity[ixAvet].color= colorAVET
                    }
                    if(bp.name=='LIBRA PROMO'){
                        bp.color=colorLP
                        let ixLp = _.findIndex(this.affinityStats.brands_per_quantity,{name:'LIBRA PROMO'})
                        this.affinityStats.brands_per_quantity[ixLp].color= colorLP
                    }
                    if(bp.name=='BREKKIES'){
                        bp.color=colorBK
                        let ixBk = _.findIndex(this.affinityStats.brands_per_quantity,{name:'BREKKIES'})
                        this.affinityStats.brands_per_quantity[ixBk].color=colorBK
                    }
                    if(bp.name=='NV DRY'){
                        bp.color=colorNVD
                        let ixND = _.findIndex(this.affinityStats.brands_per_quantity,{name:'NV DRY'})
                        this.affinityStats.brands_per_quantity[ixND].color=colorNVD
                    }
                    if(bp.name=='NV WET'){
                        bp.color= colorNVW
                        let ixNW = _.findIndex(this.affinityStats.brands_per_quantity,{name:'NV WET'})
                        this.affinityStats.brands_per_quantity[ixNW].color = colorNVW
                    }
             })

            let indexAdv= _.findIndex(this.affinityStats.brands_per_price,{name:'ADV'})
            if(indexAdv==-1){
                this.affinityStats.brands_per_price.push({gross_sum: 0,name: "ADV", total_quantity: 0, color: colorADV})
                this.affinityStats.brands_per_quantity.push({gross_sum: 0,name: "ADV", total_quantity: 0, color: colorADV})
            }
            let indexAT= _.findIndex(this.affinityStats.brands_per_price,{name:'AVET'})
            if(indexAT==-1){
                this.affinityStats.brands_per_price.push({gross_sum: 0,name: "AVET", total_quantity: 0, color: colorAVET})
                this.affinityStats.brands_per_quantity.push({gross_sum: 0,name: "AVET", total_quantity: 0, color: colorAVET})
            }
            let indexLP= _.findIndex(this.affinityStats.brands_per_price,{name:"LIBRA PROMO"})
            if(indexLP==-1){
                this.affinityStats.brands_per_price.push({gross_sum: 0,name: "LIBRA PROMO", total_quantity: 0, color: colorLP})
                this.affinityStats.brands_per_quantity.push({gross_sum: 0,name: "LIBRA PROMO", total_quantity: 0, color: colorLP})
            }
            let indexBK= _.findIndex(this.affinityStats.brands_per_price,{name:"BREKKIES"})
            if(indexBK===-1){
                this.affinityStats.brands_per_price.push({gross_sum: 0,name: "BREKKIES", total_quantity: 0,color: colorBK})
                this.affinityStats.brands_per_quantity.push({gross_sum: 0,name: "BREKKIES", total_quantity: 0,color: colorBK})
            }
            let indexNVD= _.findIndex(this.affinityStats.brands_per_price,{name:'NV DRY'})
            if(indexNVD==-1){
                this.affinityStats.brands_per_price.push({gross_sum: 0,name: "NV DRY", total_quantity: 0, color: colorNVD})
                this.affinityStats.brands_per_quantity.push({gross_sum: 0,name: "NV DRY", total_quantity: 0, color: colorNVD})
            }
            let indexNVW= _.findIndex(this.affinityStats.brands_per_price,{name:'NV WET'})
            if(indexNVW==-1){
                this.affinityStats.brands_per_price.push({gross_sum: 0,name: "NV WET", total_quantity: 0, color: colorNVW})
                this.affinityStats.brands_per_quantity.push({gross_sum: 0,name: "NV WET", total_quantity: 0, color: colorNVW})
            }
        },
        prepareAffinityBarChart(data){
          this.affinityStats.brands_per_price={
                    categories:[],
                    series:[{'name':'ADV',data:[]},{'name':'LIBRA PROMO',data:[]},{'name':'AVET',data:[]},{'name':'BREKKIES',data:[]},
                        {'name':'NV DRY',data:[]},{'name':'NV WET',data:[]}],
                }
          this.affinityStats.brands_per_quantity={
                    categories:[],
                    series:[{'name':'ADV',data:[]},{'name':'LIBRA PROMO',data:[]},{'name':'AVET',data:[]},{'name':'BREKKIES',data:[]},
                        {'name':'NV DRY',data:[]},{'name':'NV WET',data:[]}],
                }
          _.forEach(this.affinityStats,(value,key)=>{
                _.each(value.series,(serie)=>{
                    _.forEach(data,(d,k)=>{
                        let ctg= _.split(k,'_')
                        if(_.indexOf(value.categories,ctg[1])==-1){
                            value.categories.push(ctg[1])
                        }
                        let rs=  _.find(d[key],{name:serie.name})
                        if(key=='brands_per_price'){
                            if(rs){
                                serie.data.push(rs.gross_sum)
                            }else{
                                serie.data.push(0)
                            }
                        }
                        if(key=='brands_per_quantity'){
                            if(rs){
                                serie.data.push(rs.total_quantity)
                            }else{
                                serie.data.push(0)
                            }
                        }
                    })
                })
            })
            this.categoriesPHA=this.affinityStats.brands_per_price.categories
        },
        changePerformancePage(amount) {
            const nextPage = this.performance.currentPage + amount;

            if (nextPage < 1 || nextPage > this.performance.lastPage) {
                return;
            }

            this.performance.currentPage = nextPage;

            // If we have already calculated the values, we'll just return and show the cached versions.
            const isCached = this.getQuantitySeries || this.getPriceSeries;
            if (isCached) return;

            this.getPerformance();
        },
        applyDefaultFilters() {
            for (let field in this.model) {
                this.$set(this.filters, field, this.model[field]);
            }
        },

        onClearFilters() {
            this.applyDefaultFilters();
            this.hasExpandedActiveFilters = false;

            this.refresh(true);
        },

        canExportSimplified() {
            return this.userStore.hasPermissionTo('Export consumptions');
        },

        canExportDetailed() {
            return this.userStore.hasPermissionTo('Export consumptions');
        },

        exportSimplifiedData() {
            if (!this.branchStore.branch || !this.$refs.datatable_simplified) return;

            const axiosSettings = {
                url: '/api/statistics/consumptions/simplified-view/export',
                params: {
                    branch_id: this.branchStore.branch.id,
                },
            };

            this.$refs.datatable_simplified.exportData(axiosSettings, 'export_consumos_simplificados');
        },

        exportDetailedData() {
            if (!this.branchStore.branch || !this.$refs.datatable_detailed) return;

            const axiosSettings = {
                url: '/api/statistics/consumptions/detailed-view/export',
                params: {
                    branch_id: this.branchStore.branch.id,
                },
            };

            this.$refs.datatable_detailed.exportData(axiosSettings, 'export_consumos_detalhados');
        },

        changeCurrentOperator(type) {
            this.currentOperator = type;
            this.refresh(true);
        },
    },
};
</script>

<style>
.max-pagination-height > .v-pagination {
    height: 24px !important;
}
.max-pagination-height > .v-pagination .v-pagination__item {
    font-size: 12px !important;
}

.v-text-field {
    margin-top: 0 !important;
}

.v-text-field input {
    padding: 4px 0 !important;
    margin-top: 0 !important;
}

#form-base > div > .v-input > .v-input__control > .v-input__slot .v-input__icon--prepend-inner button.v-icon {
    color: #154579;
    font-size: 18px !important;
}

.consumptions-totals-title {
    font-weight: 700 !important;
    cursor: default !important;
}
#v_table_simplified_view.v-data-table{
    line-height: 18px!important;
}
#v_table_simplified_view th{
    text-align: left !important;
}
#v_table_simplified_view th span{
    line-height: 15px!important;
}
#v_table_simplified_view tr td{
    height: 35px!important;
}

#v_table_detailed_view.v-data-table{
    line-height: 18px!important;
}
#v_table_detailed_view th{
    text-align: left !important;
}
/*#v_table_detailed_view th span{
    line-height: 15px!important;
}*/
#v_table_detailed_view tr td{
    height: 35px!important;
}
#statistics #myprovet-tabs .myprovet-tab-item{
   height: 30px;
   letter-spacing: normal;
}
#statistics text.apexcharts-title-text{
  font-size: 0.875rem;
}
#statistics text.apexcharts-text.apexcharts-yaxis-label.apexcharts-xaxis-label{
  font-size: 0.5875rem;
}
#statistics .performance-info{
  line-height: normal;
  margin-top:30px;
}
#statistics .flex-row-reverse .wrap-select-ph{
    padding-top: 0px;
}
</style>
